const EditorLabelSet = {
    subtext: {
        Checkbox: {
            default: "(Please select all that apply.)",
            fr: "(Sélectionnez toutes les réponses pertinentes.)",
            es: "(Seleccione todas las que apliquen.)",
            pt: "(Assinale todas as opções aplicáveis.)"
        },
        CheckboxConstrained: {
            default: "(Please select any number of options between 111111 and 222222.)",
            fr: "(Veuillez choisir n’importe quel nombre d’options entre 111111 et 222222.)"
        },        
        Select: {
            default: "(Please select from this list.)",
            fr: "(Faites un choix à partir de cette liste.)"
        },
        Ranking: {
            default: "(Please click to select the item you wish to rank and order as desired.)",
            fr: "(Veuillez cliquer pour sélectionner l’élément que vous souhaitez classer comme vous le voulez.)"
        },
        DatePicker: {
            default: "(Click on a date within the calendar below to select a date. To change the month, click the current month. To change the year, click the current year.)",
            fr: "(Cliquez sur une date comprise dans le calendrier ci-dessous pour la sélectionner. Pour changer le mois, cliquez sur le mois en cours. Pour changer l’année, cliquez sur l’année en cours.)"             
        }
    }
};

export default EditorLabelSet 